export default __webpack_public_path__ + "static/showcase-area-957dec5a867bfa72a4ebeb5b1b5870c2.svg";